import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import {
  IAllowableActivityDTO,
  IAllowableResponsibleDTO,
} from "../../models/currentUser";
import {
  mockCurrentUserAllowableActivities,
  mockCurrentUserAllowableResponsibles,
} from "./current-user-api.mock-constants";
import { CurrentUserApi } from "./current-user-api.models";

@Injectable()
export class MockCurrentUserApiService extends CurrentUserApi {
  constructor() {
    super();
  }

  public getAllowableResponsibles(): Observable<IAllowableResponsibleDTO[]> {
    return of(mockCurrentUserAllowableResponsibles);
  }

  public getAllowableActivities(): Observable<IAllowableActivityDTO[]> {
    return of(mockCurrentUserAllowableActivities);
  }
}
